export const normalizeNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const normalizeNullableNumber = (value, fallback = 0) => {
  if (value == null) {
    return null;
  }

  return normalizeNumber(value, fallback);
};

export const getRemainingLimitProps = (limits = {}) => {
  return {
    dailyRemainingLimit: normalizeNullableNumber(limits?.daily?.remaining, 0),
    weeklyRemainingLimit: normalizeNullableNumber(limits?.weekly?.remaining, 0),
    monthlyRemainingLimit: normalizeNullableNumber(limits?.monthly?.remaining, 0),
  };
};
